import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { Component } from '@angular/core';
import { PaymentRequestLine } from '@dato-proxy/entities/paymentrequest.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-payment-request-line-document',
    templateUrl: './payment-request-line-document.component.html',
    styleUrls: ['./payment-request-line-document.component.scss']
})
export class PaymentRequestLineDocumentComponent extends BaseGridComponent<PaymentRequestLine, BaseState> {

    constructor(A: ServiceBagService) {
        super(A, 'PaymentRequestLineDocumentComponent', PaymentRequestLine, BaseState);
    }

}
